<template>
  <div class="TituloSeccion">
    <font-awesome-icon  :icon="icon" size="4x" :style="{ color: 'black'}"  class="IconoTituloSeccion fLeft"/>
    
    <div v-if="productor && establecimiento" class="fLeft aliLeft Ajuste1">
      <b>{{ seccion }} de {{ productor }}</b>
      <br>
      {{ establecimiento }}
    </div>
    <div v-else class="fLeft">{{ seccion }}</div>
    
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  props: {
    seccion: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    productor: {
      type: String,
      required: false
    },
    establecimiento: {
      type: String,
      required: false
    }
  }
}
</script>

<style style lang="scss" scoped>
@import "../Css/Componentes.scss";

  .Ajuste1 {
    max-width: calc(100% - 55px);
    line-height:20px;
    font-weight: normal;
  }
  @media (max-width: 799px) {
    // mobile
    .Ajuste1{
      max-width: calc(100% - 40px);
    }
  }
</style>